import { ReactNode } from 'react';

type StepCardSummaryProps = {
  children?: ReactNode;
};

export function StepCardSummary({ children }: StepCardSummaryProps) {
  if (!children) return null;
  return (
    <div className="px-8 py-4 bg-neutral-50 rounded-b-2xl">{children}</div>
  );
}

export default StepCardSummary;
